// Kokabo JavaScript library ES6.
// Author: Benoit Pereira da Silva
// License: MIT
// Version: 2.0.0
// Description: A JavaScript library to communicate using the Kokabo (including RPC protocol over Websockets).
// It is a simple and efficient Event Oriented implementation.
// When Websockets are not available, you can interact with Go backend via its REST API.
// It comes with a simple logging facility and a set of utilities.
// It is designed to be used in the browser.
//
// Main classes :
// - HubEvent: A custom Bidirectional event dispatched by or to a Hub instance.
// - Hub: A bidirectional communication channel (relying on WebSocket) and respecting the Kokabo RPC protocol.
// - Hubs: A class that manages Hub instances.
// - Log: A simple logging facility that can log to the console or to an HTML element.
// - Utils: A set of utilities.
// - RestApi: A class that provides a simple REST API client for Kokabo's api.
// - Popups: A class to deal with browser windows popups.


import {SecurityAgent} from "./security/SecurityAgent.js";
import {SecurityPolicy, DefaultSecurityPolicy, OptOutE2EESecurityPolicy} from "./security/SecurityPolicy.js";
import {Hub, HubEvent} from "./rpc/Hub.js";
import {Hubs} from "./rpc/Hubs.js";

import {Log} from "./utils/Log.js";
import {Utils} from "./utils/Utils.js";
import {Popups} from "./utils/Popups.js";


export {SecurityAgent, SecurityPolicy, DefaultSecurityPolicy, OptOutE2EESecurityPolicy, HubEvent, Hub, Hubs, Log, Utils, Popups};